import {Text, View, StyleSheet} from "@react-pdf/renderer";
import {FC} from "react";

const styles = StyleSheet.create({
  paragraph: {
    fontFamily: 'BlinkMacSystemFont',
    fontStyle: 'light',
    lineHeight: 1.714,
  },
  block: {
    fontFamily: 'BlinkMacSystemFont',
    fontStyle: 'light',
    backgroundColor: '#f3f2f8',
    color: '#3888ae',
    borderRadius: 4,
  },
  rowNumber: {
    backgroundColor: '#e2e4e8',
    justifyContent: 'center',
    color: '#8892a5',
    height: 15,
    width: 17,
    textAlign: 'center',
    fontSize: 8,
  },
  code: {
    fontFamily: 'SourceCodePro',
    fontStyle: 'regular',
    alignItems: 'center',
    fontSize: 8,
  }
})

type PropsType = {
  companyAPIKey: string;
  propertyId: string;
}

const CodeBlockGTM: FC<PropsType> = ({companyAPIKey, propertyId}) => {
  const addRow = (row: number = 1, code: string, tabulation: number = 0, borderTopLeftRadius: number = 0, borderBottomLeftRadius: number = 0) => {
    let marginLeft = 5 + (20 * tabulation)
    return (
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={{
          ...styles.rowNumber,
          borderTopLeftRadius: borderTopLeftRadius,
          borderBottomLeftRadius: borderBottomLeftRadius,
        }}><Text>{row}</Text></View>
        <Text style={{marginLeft: marginLeft, ...styles.code}}>{code}</Text>
      </View>
    )
  }

  return (
    <View style={styles.block}>
      {addRow(1, `<script>`, 0, 4)}
      {addRow(2, `(function () {`, 0)}
      {addRow(3, `var script = document.createElement('script');`, 1)}
      {addRow(4, `var style = document.createElement("link");`, 1)}
      {addRow(5, `var div = document.createElement("div");`, 1)}
      {addRow(6, `function applyConfigs(elem, config) {`, 1)}
      {addRow(7, `for (var key in config) {`, 2)}
      {addRow(8, `elem.setAttribute(key, config[key]);`, 3)}
      {addRow(9, `}`, 2)}
      {addRow(10, `}`, 1)}
      {addRow(11, `var mainDivConfig = {`, 1)}
      {addRow(12, `id: "handiscover-accessibility-widget",`, 2)}
      {addRow(13, `class: "handiscover-accessibility-widget",`, 2)}
      {addRow(14, `companyId: "${companyAPIKey}",`, 2)}
      {addRow(15, `propertyId: "${propertyId}",`, 2)}
      {addRow(16, `}`, 1)}
      {addRow(17, `var styleConfig = {`, 1)}
      {addRow(18, `rel: "stylesheet",`, 2)}
      {addRow(19, `href: "https://accessibility-widget.handiscover.com/dist/index.css"`, 2)}
      {addRow(20, `}`, 1)}
      {addRow(21, `var scriptConfig = {`, 1)}
      {addRow(22, `src: "https://accessibility-widget.handiscover.com/dist/index.js"`, 2)}
      {addRow(23, `}`, 1)}
      {addRow(24, `applyConfigs(div, mainDivConfig);`, 1)}
      {addRow(25, `applyConfigs(style, styleConfig);`, 1)}
      {addRow(26, `applyConfigs(script, scriptConfig);`, 1)}
      {addRow(27, `var body = document.getElementsByTagName("body")[0];`, 1)}
      {addRow(28, `if (body) {`, 1)}
      {addRow(29, `body.append(div);`, 2)}
      {addRow(30, `body.append(style);`, 2)}
      {addRow(31, `body.append(script);`, 2)}
      {addRow(32, `}`, 1)}
      {addRow(33, `}`, 0)}
      {addRow(34, `)()`, 0)}
      {addRow(35, `</script>`, 0, 0, 4)}
    </View>
  )
}

export default CodeBlockGTM